// TODO: Migrate My Plans to Microapp

import {Component, Input} from '@angular/core';
import {Plan} from '@ox/typings';

@Component({
  selector: 'webu-plain-plan-template',
  templateUrl: './plain-plan-template.html'
})
export class PlainPlanTemplateComponent {
  @Input () plan : Plan;
  @Input () userRole : string;
  @Input () isVehicleOverviewPage: boolean;
  
}
